<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div data-slot="table-container" class="relative w-full overflow-auto shadow-xs rounded-lg border border-gray-100">
    <table data-slot="table" :class="cn('w-full caption-bottom font-inter text-base', props.class)">
      <slot />
    </table>
  </div>
</template>
